import {
  Box,
  Text,
  Heading,
  Button,
  Flex,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AddFollowUpModal from "../../../Components/AddFollowUpModal";
import FollowUpTimeline from "../../../Components/FollowUpTimeline";
import axios from "axios";
import Navbar from "../../../Components/Navbar";
import { ChevronDownIcon, ChevronRightIcon } from "@chakra-ui/icons";
import AdminSidebar from "../../../Components/AdminSidebar";
const BASE_URL = "https://develop-project-360.onrender.com";
export const getLeadById = (id) =>
  axios.get(`${BASE_URL}/getLeadDealById/${id}`);

export const updateLeadStatus = (id, newStatus) =>
  axios.put(`https://develop-project-360.onrender.com/updateLeadDeal/${id}`, {
    status: newStatus,
  });

const statusOptions = [
  "New",
  "Contacted",
  "Qualified",
  "Proposal Sent",
  "Negotiation",
  "Won",
  "Lost",
];

export default function DealDetail() {
  const { id } = useParams();
  const [lead, setLead] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const toast = useToast();
  //console.log("lead", lead);

  useEffect(() => {
    const fetchLead = async () => {
      const res = await getLeadById(id);
      setLead(res.data.data);
    };
    fetchLead();
  }, [id, refresh]);

  if (!lead) return <Text>Loading...</Text>;

  const handleStatusChange = async (newStatus) => {
    try {
      const res = await updateLeadStatus(lead._id, newStatus);
      setLead((prevLead) => ({
        ...prevLead,
        status: newStatus,
      }));
      toast({
        title: "Status Updated",
        description: `Lead status changed to ${newStatus}`,
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
        variant: "subtle",
      });
    } catch (err) {
      toast({
        title: "Error",
        description: err.response?.data?.error || "Failed to update status",
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
        variant: "subtle",
      });
    }
  };

  return (
    <Flex>
      <AdminSidebar />
      <Box
        pl={{ base: "none", md: "10" }}
        pt={{ base: "none", md: "10" }}
        w={{ base: "100%", md: "80%" }}
      >
        <Navbar />

        {/* Main Content */}
        <Box flex="1" p={[4, 6]} overflowY="auto">
          <Heading size={"md"} textAlign={"start"}>
            Deals
          </Heading>
          <Flex
            direction={{ base: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ base: "flex-start", md: "center" }}
            flexWrap="wrap"
            gap={4}
          >
            <Breadcrumb
              spacing="8px"
              mt={6}
              mb={6}
              separator={<ChevronRightIcon color="gray.500" />}
            >
              <BreadcrumbItem>
                <BreadcrumbLink href="/admin">Dashboard</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <BreadcrumbLink href="/deals">Deals</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <BreadcrumbLink href="#">
                  <Heading textAlign={"start"} size={"sm"}>
                    {lead.description}
                  </Heading>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <BreadcrumbLink href="#">
                  <Heading textAlign={"start"} size={"sm"}>
                    {lead.client_name}
                  </Heading>
                </BreadcrumbLink>
              </BreadcrumbItem>
            </Breadcrumb>

            <Flex
              justifyContent={{ base: "flex-start", md: "flex-end" }}
              w={{ base: "100%", md: "auto" }}
              gap={5}
            >
              <AddFollowUpModal
                leadId={id}
                onAdd={() => setRefresh(!refresh)}
              />
              <Menu>
                <MenuButton
                  as={Button}
                  rightIcon={<ChevronDownIcon />}
                  size="sm"
                  bgGradient="linear(to-r, green.300, teal.100)"
                  _hover={{ bgGradient: "linear(to-r, green.100, green.400)" }}
                >
                  Status: {lead.status}
                </MenuButton>
                <MenuList>
                  {statusOptions.map((status) => (
                    <MenuItem
                      key={status}
                      onClick={() => handleStatusChange(status)}
                      fontWeight={lead.status === status ? "bold" : "normal"}
                    >
                      {status}
                    </MenuItem>
                  ))}
                </MenuList>
              </Menu>
            </Flex>
          </Flex>

          <Box
            p={6}
            boxShadow={"xl"}
            borderRadius={"2xl"}
            minH={700}
            display="flex"
            flexDirection="column"
            // justifyContent="center"
            alignItems="center"
          >
            {lead.follow_ups && lead.follow_ups.length > 0 ? (
              <FollowUpTimeline
                followUps={lead.follow_ups}
                leadId={lead._id}
                lead={lead}
              />
            ) : (
              <Text fontSize="lg" color="gray.500" textAlign="center">
                No follow-up pending, Create one
              </Text>
            )}
          </Box>
        </Box>
      </Box>
    </Flex>
  );
}
